export default "__VITE_ASSET__D$vK_onx__"